import { useState } from "react";

import { confirmUserName } from "@/apis/user";
import Button from "@/components/Button";
import Input from "@/components/Input/Input";
import ModalLayout from "@/components/Layout/ModalLayout";
import useLoginStore from "@/store/loginStore";
import useUserStore from "@/store/userStore";

interface NameConfirmModalProps {
  onClose: () => void;
}

const NameConfirmModal = ({ onClose }: NameConfirmModalProps) => {
  const { tokenId } = useLoginStore();
  const { userName, saveUserInfo } = useUserStore();
  const userState = useUserStore();
  const [name, setName] = useState(userName);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!name.trim()) return;

    setLoading(true);
    try {
      await confirmUserName(tokenId, name.trim());
      saveUserInfo({
        ...userState,
        userName: name.trim(),
        nameConfirmed: "Y",
      });
      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalLayout variant="primary" onClose={() => {}}>
      <div className="flex w-80 flex-col gap-4 p-6">
        <div className="text-center">
          <h2 className="text-lg font-bold">실명 확인</h2>
          <p className="mt-1 text-sm text-gray-500">
            예약자 확인을 위해 실명을 확인해주세요.
          </p>
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-700">이름</label>
          <Input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="실명을 입력하세요"
            variant="default"
          />
          <p className="text-xs text-red-500">
            * 카카오톡 닉네임이 아닌 실명을 입력해주세요.
          </p>
        </div>

        <div className="flex justify-center">
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={!name.trim() || loading}
          >
            {loading ? "저장 중..." : "확인"}
          </Button>
        </div>
      </div>
    </ModalLayout>
  );
};

export default NameConfirmModal;
